import { render, staticRenderFns } from "./manage-notification.vue?vue&type=template&id=b75b0e86&scoped=true"
import script from "./manage-notification.vue?vue&type=script&lang=ts"
export * from "./manage-notification.vue?vue&type=script&lang=ts"
import style0 from "./manage-notification.vue?vue&type=style&index=0&id=b75b0e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75b0e86",
  null
  
)

export default component.exports